<template>
	<AssessmentCharacteristics class="meeting-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `calendar-check` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.MeetingCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "MeetingCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.effectiveMeetingGuidance || [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
